const DefaultColorTheme = {
    "light": {
        "palette": {
            "primary": {
                "main": "#583F99",
                "light": "#EBE8F3"
            },
            "secondary": {
                "lighter": "#F4F5F5",
                "light": "#E8EAEA",
                "main": "#F99D27"
            },
            "tertiary": {
                "light": "#E7D7DC",
                "main": "#7E5465"
            },
            "background": {
                "paper": "#fff",
                "default": "#F1F3F3",
                "secondary": "#FDFDFD",
                "tertiary": "#EBEBEB"
            },
            "warning": {
                "light": "#FDEDD3",
                "main": "#F8B858"
            },
            "error": {
                "light": "#FDEBEB",
                "main": "#EB5757"
            },
            "success": {
                "light": "#E6F3ED",
                "main": "#219653",
                "dark": "#2C9765"
            },
            "common": {
                "white": "#FFF",
                "black": "#000"
            },
            "divider": '#0000001F',
            "text": {
                "primary": "#1E1E1E",
                "secondary": "#4F4F4F",
                "tertiary": "#828282",
                "disabled": "#BDBDBD"
            },
            "app-specific": {
                'scroll-bar': {
                    'track': 'transparent',
                    'thumb': '#a4a3a2',
                },
                "chart": {
                    "1": "#003f5c",
                    "2": "#2f4b7c",
                    "3": "#665191",
                    "4": "#a05195",
                    "5": "#d45087",
                    "6": "#f95d6a",
                    "7": "#ff7c43",
                    "8": "#ffa600"
                },
                "shadow": "#EBEBEB",
                "data-grid": {
                    "loading-overlay-background": "#0000001a",
                    "cell-border-color": "#F8F8F8",
                    "selected-cell-background-color": "var(--palette-secondary-light)",
                    "hovered-cell-background-color": "var(--palette-secondary-lighter)",
                    "grouped-row-cell-background-color": "var(--palette-secondary-light)",
                    "last-left-pinned-box-shadow-color": "#0000000d",
                    "first-right-pinned-box-shadow-color": "#0000000d",
                    "detailed-panel-box-shadow": "#ffffff00",
                    "switch-wrapper-box-shadow": "#00000038",
                    "popover-shadow-color": "#0000001c"
                },
                "card-border-color": "var(--palette-secondary-light)"
            }
        }
    },
    "dark": {
        "palette": {
            "primary": {
                "main": "#8F7ABB",
                "light": "#121212"
            },
            "secondary": {
                "lighter": "#2C2C2C",
                "light": "#1b1b1b",
                "main": "#FEDE88"
            },
            "tertiary": {
                "light": "#2E2E2E",
                "main": "#80D7FF"
            },
            "background": {
                "paper": "#252525",
                "default": "#121212",
                "secondary": "#2c2c2c",
                "tertiary": "#2c2c2c"
            },
            "warning": {
                "light": "#484528",
                "main": "#FFEB3B"
            },
            "error": {
                "light": "#4D2829",
                "main": "#ED323B"
            },
            "success": {
                "light": "#233530",
                "main": "#1DE9B6",
                "dark": "#2C9765"
            },
            "common": {
                "white": "#FFF",
                "black": "#000"
            },
            divider: '#FFFFFF1F',
            "text": {
                "primary": "#DEDEDE",
                "secondary": "#A0A0A0",
                "tertiary": "#7d7d7d",
                "disabled": "#414141"
            },
            "app-specific": {
                'scroll-bar': {
                    'track': 'transparent',
                    'thumb': '#656565FF',
                },
                "chart": {
                    "1": "#ffa600",
                    "2": "#ff7c43",
                    "3": "#f95d6a",
                    "4": "#d45087",
                    "5": "#a05195",
                    "6": "#665191",
                    "7": "#2f4b7c",
                    "8": "#003f5c"
                },
                "shadow": "#00000052",
                "data-grid": {
                    "loading-overlay-background": "#ffffff1a",
                    "cell-border-color": "#2c2c2c",
                    "selected-cell-background-color": "#454545",
                    "hovered-cell-background-colo": "#2c2c2c",
                    "grouped-row-cell-background-color": "#454545",
                    "last-left-pinned-box-shadow-color": "#00000052",
                    "first-right-pinned-box-shadow-color": "#00000052",
                    "detailed-panel-box-shadow": "#ffffff4d",
                    "switch-wrapper-box-shadow": "#ffffff40",
                    "popover-shadow-color": "#00000052"
                },
                "card-border-color": "#4B5D66"
            }
        }
    }
}

export const MaskedColorTheme = {
    "light": {
        "palette": {
            "primary": {"main": "#583F99", "light": "#eeecf5"},
            "secondary": {"lighter": "#fff8f0", "light": "#fef0df", "main": "#F99D27"},
            "tertiary": {"light": "#f2eef0", "main": "#7e5465ff"},
        }
    }, "dark": {
        "palette": {
            "primary": {"main": "#9a84d4", "light": "#121212"},
            "secondary": {"lighter": "#2C2C2C", "light": "#1b1b1b", "main": "#ffd797"},
            "tertiary": {"light": "#2E2E2E", "main": "#c1f7ff"},
        }
    }
}

// Bizkey Tech:
// primary: '#583f99ff',
// secondary: '#f99d27ff',
// tertiary: '#7e5465ff',

// CHTP
// primary: '#E42C5E',
// secondary: '#005BAA',
// tertiary: '#7E5465',

// Horse-barn:
//  primary: '#E51622',
//  secondary: '#E8CC69',
//  tertiary: '#8B5E3C',

// Myers Controls:
//  primary: '#0068B3',
//  secondary: '#F37736',
//  tertiary: '#8B5E3C',

// Cascade AquaTech
//  primary: '#033069ff',
//  secondary: #5c3e03ff,
//  tertiary: #df00f2ff,

// Sinkut Radiators
// primary: '#0C598D',
// secondary: '',
// tertiary: '',

// Roppel Industries
// primary: '#003da4',
// secondary: '#f9ed8a',

export default DefaultColorTheme;
